import { Container } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { COLOR_TOKEN } from '../../../../../helpers/color-tokens';

export const BonoCardBackground = styled(Container)<{ bgColor?: string }>`
	border-radius: 16px;
	background: ${({ bgColor }) => bgColor || COLOR_TOKEN.gradient.radial};
	padding: var(--size-dynamic0130);
`;
